/**
 * Web i18n setup — react-i18next + HttpBackend.
 *
 * Locale JSON files are served from `/locales/{lng}/{ns}.json` under the web
 * app's static root. Session 0.6 wires vite-plugin-static-copy in vite.config.ts
 * so the locales folder is mirrored from packages/i18n/locales/ at dev-start
 * and build time — do NOT edit files under public/locales/ directly.
 *
 * The namespace list matches @jeanieiq/i18n's NAMESPACES constant (13 items —
 * latest additions: `stock` (3.1), `directory` (3.2), `glossary` (3.3)). The
 * shared package is the single source of truth; this file is the runtime glue
 * for React hooks.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { NAMESPACES, DEFAULT_LOCALE } from '@jeanieiq/i18n';

import { companyCurrencySymbol } from './lib/companyMoney';
import { followCompanyLocale } from './lib/companyLanguage';
import { queryClient } from './lib/queryClient';

void i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: document.documentElement.lang || DEFAULT_LOCALE,
    fallbackLng: DEFAULT_LOCALE,
    ns: [...NAMESPACES],
    defaultNS: 'common',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    interpolation: {
      // React already escapes; i18next escaping would double-encode.
      escapeValue: false,
      // {{currency}} in any string is the company's symbol, read when the
      // string is drawn.
      defaultVariables: {
        get currency() {
          return companyCurrencySymbol();
        },
      },
    },
    react: {
      // Suspense disabled so the app renders immediately and falls back to
      // the key string on first paint rather than suspending the whole tree.
      useSuspense: false,
    },
  });

followCompanyLocale(queryClient, i18n);

export default i18n;
